import { render } from "./delete-user.vue?vue&type=template&id=61fffcee&scoped=true&ts=true"
import script from "./delete-user.vue?vue&type=script&lang=ts"
export * from "./delete-user.vue?vue&type=script&lang=ts"

import "./delete-user.vue?vue&type=style&index=0&id=61fffcee&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61fffcee"]])

export default __exports__